exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mobile-user-avatar-with-name{display:flex;height:22px;margin-left:-5px;cursor:pointer;margin-bottom:14px}.mobile-user-avatar-with-name .user-line{position:static;top:75px;border:none;width:200px;height:1px;margin:0;border-top:1px solid #ddd}.mobile-user-avatar-with-name .mobile-user-list-container .mobile-user-list-box{display:flex;flex-direction:row;width:100%}.mobile-user-avatar-with-name .mobile-user-list-container .mobile-user-list-box .mobile-user-name{width:250px;margin-top:4px;font-family:Open Sans,sans-serif;font-weight:400;font-size:14px;letter-spacing:0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.mobile-user-avatar-with-name .mobile-user-list-container .mobile-user-list-box .mobile-button-container .add-button{position:absolute;margin-top:4px;text-align:center;font-family:Open Sans,sans-serif;font-size:10px;font-weight:600;background-color:#184e78;width:56px;height:20px;border-radius:3px;color:#fff;border:1px solid #184e78;cursor:pointer}.mobile-user-avatar-with-name .mobile-user-list-container .mobile-user-list-box .mobile-button-container .add-button:focus{outline:none}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserAvatar/MobileUserAvatarWithName/UserAvatarWithName.scss
// module id = 1674
// module chunks = 0